<style lang="less">
@import "../../../styles/public/public.less";
@import "../less/unit.less";
</style>
<template>
<div class="unit media_w_w14">
    <div class="unit1 display_column">
        <div class="unit_nr dispaly_flex11 display_row">
            <div class="unit_nr_1 display_column dispaly_flex11 set_yj">
                <titles titles="单位信息"></titles>
                <div class="unit_table dispaly_flex11">
                    <div class="unit_table_wrap">
                        <table>
                            <thead>
                                <tr>
                                    <td style="width:50px;">
                                        <Checkbox v-model="floge" @on-change="click_gx"></Checkbox>
                                    </td>
                                    <td style="width:80px;">序号</td>
                                    <td>单位名称</td>
                                    <td>单位负责人</td>
                                    <td>联系电话</td>
                                    <td style="width:150px;">操作</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item,index in list" :class="{'unit_table_hover':item.judge}" @click.stop="clickView(item,$event)">
                                    <td>
                                        <Checkbox v-model="item.floge" @on-change="click_dgx"></Checkbox>
                                    </td>
                                    <td>{{index + 1}}</td>
                                    <td>{{item.mc}}</td>
                                    <td>{{item.fzr}}</td>
                                    <td>{{item.dh}}</td>
                                    <td>
                                        <Button @click="clickModify(item,$event)" size="small" type="warning">修改</Button>
                                        <!-- <Button @click="clickView(item,$event)" size="small" type="error">查看</Button> -->
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="unit_page display_row_je_ac dispaly_flex00">
                    <div>
                        <Page :total="total" :page-size="page" :current="current" :page-size-opts="pageOpts" placement="top" show-elevator show-sizer show-total />
                    </div>
                </div>
            </div>
            <div class="unit_nr_2 dispaly_flex00 media_w_unitnr2">
                <showmodel v-show="disabled"></showmodel>
                <modifymodel v-show="!disabled"></modifymodel>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import showmodel from "./showmodel.vue";
import modifymodel from "./modifymodel.vue";
import titles from "../../pages/title.vue";
import bus from "../../../app/event";
export default {
    components: {
        showmodel,
        titles,
        modifymodel
    },
    data() {
        return {
            floge: false,
            page: appPage.page, //每页数量
            pageOpts: appPage.pageOpts, //每页数量分类
            total: 0, //总数
            current: 1,
            list: [],
            disabled: true,
            displayData: {},
            keywords:'',          
        };
    },
    methods: {
        showJudge: function (item, event) {
            //阻止冒泡
            event = event ? event : window.event;
            event.cancelBubble = true;
            for (var i = 0; i < this.list.length; i++) {
                this.list[i].judge = false;
            }
            item.judge = true;
        },
        //修改
        clickModify: function (item, event) {
            this.showJudge(item, event);
            this.disabled = false;
            bus.$emit('newunit', item,true);
        },
        //查看
        clickView: function (item, event) {
            this.showJudge(item, event);
            this.disabled = true;
            bus.$emit('showunit', item);
        },
        click_gx: function (item) {
            for (var i = 0; i < this.list.length; i++) {
                this.list[i].floge = item;
            }
        },
        click_dgx: function () {
            var judge = true;
            for (var i = 0; i < this.list.length; i++) {
                if (this.list[i].floge == false) {
                    judge = false;
                }
            }
            this.floge = judge;
        },
        query: function () {
            this.disabled=true;
            this.list = [];
            this.$http.post(
                    appurl.ip + "/ylkjservice/services/hander.ashx?action=listorg", {
                        SSDW: sessionStorage.getItem("SSDW"),
                        AOTHOR_ID:sessionStorage.getItem("AOTHOR_ID"),
                        DWMC:this.keywords,
                        pageSize:this.page,
                        pageNumber:this.current,
                    }
                )
                .then(res => {
                    if (res.status == 200) {
                        let rawData = res.data;
                        this.total=rawData.length;
                        rawData.forEach(ele => {
                            this.list.push({
                                judge: false,
                                mc: ele.DWMC,
                                dh: ele.PHONENUM,
                                fzr: ele.FZR,
                                floge: false,
                                yb: ele.ZIPCODE,
                                dwdz: ele.DWADDRESS,
                                dwxz: ele.KIND,
                                id:ele.ID,
                                parent_id:ele.PARENT_ID,
                                creditcode:ele.CREDITCODE,
                                imgurl:ele.CREDITIMG
                            });
                        });
                        this.displayData = this.list[0];
                        bus.$emit('showunit', this.displayData);
                    }
                })
                .catch(error => {
                    this.$Message.warning({
                        content: "访问失败！",
                        duration: 3
                    });
                })
        },
        //删除
        delunit:function(){
            let str='';
            let inde=null;
            let flag=this.list.filter(item=>item.floge);
            if(this.list.filter(item=>item.floge).length==0){
                this.$Message.warning('没有选择删除项');
                return
            }
            str=this.list.filter(item=>item.floge).map(item=>item.id).join(",");
            this.$Modal.confirm({
                title: "删除",
                content: "是否确认删除？",
                onOk: () =>{
                    this.$http.post(
                        appurl.ip + "/ylkjservice/services/hander.ashx?action=delorg", {
                            ID: str
                        }
                    )
                    .then(res => {
                        if (res.status == 200&&res.data.success=='true') {
                            this.$Message.success('删除成功');
                            this.query();
                        }
                        else{
                            this.$Message.warning('删除失败');
                        }
                    })
                    .catch(error => {
                        this.$Message.warning({
                            content: "访问失败！",
                            duration: 3
                        });
                    })
                }
            })           
        },
        click_state: function (item) {
            switch (item) {
                case "新增":
                    this.disabled = false;
                    bus.$emit('newunit', {});
                    break;
                case "删除":
                    this.delunit();
                default:
                    break;
            }

        }
    },
    mounted() {
        this.query();
        bus.$on("operations_new", this.click_state);
        bus.$on('refreshunit',this.query);
        bus.$on('contentsearch',(keywords)=>{
            this.keywords=keywords;
            this.query();
        })
        bus.$emit('clearkeywords');
    },
    beforeDestroy() {
        bus.$off('operations_new', this.click_state);
        bus.$off('refreshunit',this.query);
        bus.$off('contentsearch');
    },
};
</script>



// WEBPACK FOOTER //
// unit.vue?3efd92a4